export enum ErrorPathEnum {
  ERROR = "/error",
}
